var _path, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPartner1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 84,
    viewBox: "0 0 84 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4734_2508)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4734_2508",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: -1,
    width: 84,
    height: 85
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 -0.00585175H84V83.9941H0V-0.00585175Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4734_2508)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M82.7695 55.465V65.3457C82.7695 68.0624 80.5662 70.2676 77.8476 70.2676H6.15234C3.43383 70.2676 1.23047 68.0624 1.23047 65.3457V23.5687C1.23047 20.8518 3.43383 18.6468 6.15234 18.6468H20.288",
    stroke: "#01A5AF",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.7148 18.6446H77.8505C80.569 18.6446 82.7723 20.8496 82.7723 23.5665V49.7207",
    stroke: "#01A5AF",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.288 23.5687H6.64453C6.37268 23.5687 6.15234 23.7892 6.15234 24.0609V65.3457H77.3555C77.6273 65.3457 77.8476 65.1252 77.8476 64.8535V24.0609C77.8476 23.7892 77.6273 23.5687 77.3555 23.5687H63.712",
    stroke: "#01A5AF",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.7969 70.2647V77.8418",
    stroke: "#01A5AF",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.2031 77.8418V70.2647",
    stroke: "#01A5AF",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.5821 77.8418H34.4219C31.9754 77.8418 29.9922 79.825 29.9922 82.2715C29.9922 82.5433 30.2125 82.7637 30.4844 82.7637H53.5196C53.7914 82.7637 54.0118 82.5433 54.0118 82.2715C54.0118 79.825 52.0286 77.8418 49.5821 77.8418Z",
    stroke: "#01A5AF",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.2891 65.3457V6.14933C20.2891 3.43098 22.4927 1.22746 25.2109 1.22746H58.7899C61.5081 1.22746 63.7118 3.43098 63.7118 6.14933V65.3457",
    stroke: "#01A5AF",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.3183 11.4956C35.7415 9.6822 38.7475 8.60742 42 8.60742C50.0059 8.60742 56.5195 15.1209 56.5195 23.127C56.5195 31.1329 50.0059 37.6465 42 37.6465C33.9939 37.6465 27.4805 31.1329 27.4805 23.127C27.4805 20.4385 28.215 17.9181 29.4937 15.7564",
    stroke: "#01A5AF",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.5206 29.5508C38.6803 29.5508 37.8403 29.2312 37.2006 28.5917L34.4746 25.8654C33.5137 24.9044 33.5137 23.3463 34.4747 22.3852C35.4358 21.4243 36.9941 21.4239 37.955 22.3852L39.1727 23.603C39.3649 23.7953 39.6765 23.7953 39.8688 23.603L45.996 17.4758C46.933 16.5388 48.4593 16.4525 49.4394 17.3444C50.4858 18.2964 50.5145 19.9179 49.5255 20.9067L41.8408 28.5913C41.2011 29.231 40.3608 29.5508 39.5206 29.5508Z",
    stroke: "#01A5AF",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.832 45.6855H56.1679",
    stroke: "#01A5AF",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.832 53.0684H56.1679",
    stroke: "#01A5AF",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4734_2508"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 84,
    height: 84,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPartner1);
export default __webpack_public_path__ + "static/media/partner-1.da6dc62bf903bfe4797dfe15b65564b6.svg";
export { ForwardRef as ReactComponent };